<template>
    <!--用餐评价-->
    <div class="view" :style="{paddingTop:navbarheight}">
        <div class="content">
            <my-top title="用餐评价" lefttext="返回" @leftclick="togo('/application/canteen/evaluate')"></my-top>
            <Form ref="form">
                <cell :title="'单位：'+form.unitName"></cell>
                <cell v-for="(item, n) in form.topics" :key="n">
                    <template #title>{{item.topicName}}</template>
                    <template #label>
                        <div>
                            <radio-group :disabled="disabled" v-if="item.type === 'checkbox'" v-model="item.optionsScore" direction="horizontal">
                                <div v-for="(items, k) in item.options" style="min-width: 50%;margin-bottom: 10px;">
                                    <radio @click="handleClick(items, n, k)"
                                           ref="checkboxes"
                                           :name="n !== 14 ? items.score : items.choose"
                                           :key="n+'-'+k" >{{items.optionsName}}</radio>
                                </div>
                            </radio-group>
                            <div class="formCtn" v-if="item.type === 'textarea'">
                                <field v-model="item.options[0].optionsName"
                                       :disabled="disabled"
                                       rows="2"
                                       autosize
                                       show-word-limit
                                       type="textarea"
                                       maxlength="300"
                                       placeholder="请输入" />
                            </div>
                        </div>
                    </template>
                </cell>
                <cell :title="'总分：'+form.score"></cell>
            </Form>
        </div>
        <div class="btnSub" v-if="!disabled">
            <van-button block type="info" :loading="loadingSub" loading-text="提交中..."  @click="handleValidate">提交</van-button>
        </div>
    </div>
</template>

<script>
    import {Button, Cell, CellGroup, Dialog, Field, Form, Loading, Radio, RadioGroup} from "vant";
    import UploadList from "@components/UploadListVant/index.vue";
    import application from '@api/application';

    export default {
        name: "canteenEvaluateForm",
        components: {Cell, Form, CellGroup, Field, Button, Loading,RadioGroup, Radio,UploadList,Dialog},
        data() {
            return {
                checkboxGroup: [],
                UploadError:false,
                uploadStatus:false, //图片上传状态
                loadingSub:false,
                query:this.$route.query,
                disabled:this.$route.query.disabled || false,
                listId:this.$route.query.listId,
                fileId: [], //文件ID,多个使用,隔开
                form:{
                    unitId: JSON.parse(localStorage.getItem("vuex")).user.company.id,
                    unitName: JSON.parse(localStorage.getItem("vuex")).user.company.name,
                    orgId: JSON.parse(localStorage.getItem("vuex")).user.company.deptId,
                    score: 0, //总分
                    topics:[
                        {
                            type: 'checkbox',
                            topicName: '1, 你对食堂食堂整体感觉如何？', //题目
                            optionsScore: '', //得分
                            options:[
                                {
                                    choose: 'A', // 1是， 0否
                                    score: 5,
                                    optionsName: 'A 非常满意',
                                },{
                                    choose: 'B',
                                    score: 3,
                                    optionsName: 'B 很满意',
                                },{
                                    choose: 'C',
                                    score: 2,
                                    optionsName: 'C 一般',
                                },{
                                    choose: 'D',
                                    score: 0,
                                    optionsName: 'D 不满意',
                                },
                            ]
                        },{
                            type: 'checkbox',
                            topicName: '2, 您对食堂菜菜品搭配是否满意？',
                            optionsScore: '',
                            options:[
                                {
                                    choose: 'A',
                                    score: 5,
                                    optionsName: 'A 荤素搭配很合理,健康又美味',
                                },{
                                    choose: 'B',
                                    score: 3,
                                    optionsName: 'B 荤素搭配一般,几个菜重复,没有新意',
                                },{
                                    choose: 'C',
                                    score: 2,
                                    optionsName: 'C 搭配不合理,不好吃',
                                },{
                                    choose: 'D',
                                    score: 0,
                                    optionsName: 'D 完全没搭配',
                                },
                            ]
                        },{
                            type: 'checkbox',
                            topicName: '3, 您对食堂就餐环境、卫生是否满意？', //题目
                            optionsScore: '', //得分
                            options:[
                                {
                                    choose: 'A', // 1是， 0否
                                    score: 5,
                                    optionsName: 'A 非常满意',
                                },{
                                    choose: 'B',
                                    score: 3,
                                    optionsName: 'B 很满意',
                                },{
                                    choose: 'C',
                                    score: 2,
                                    optionsName: 'C 一般',
                                },{
                                    choose: 'D',
                                    score: 0,
                                    optionsName: 'D 不满意',
                                },
                            ]
                        },{
                            type: 'checkbox',
                            topicName: '4, 您对食堂饭菜口味是否满意？', //题目
                            optionsScore: '', //得分
                            options:[
                                {
                                    choose: 'A',
                                    score: 5,
                                    optionsName: 'A 很好,非常不错',
                                },{
                                    choose: 'B',
                                    score: 3,
                                    optionsName: 'B 还行吧,偶尔时味道是可以的',
                                },{
                                    choose: 'C',
                                    score: 2,
                                    optionsName: 'C 一般般,将就吃吧',
                                },{
                                    choose: 'D',
                                    score: 0,
                                    optionsName: 'D 有待提高,没吃过这么难吃的员工餐厅',
                                }
                            ]
                        }, {
                            type: 'checkbox',
                            topicName: '5, 您对食堂工作人员的服务态度是否满意？', //题目
                            optionsScore: '', //得分
                            options:[
                                {
                                    choose: 'A',
                                    score: 5,
                                    optionsName: 'A 和善可亲,服务很舒心',
                                },{
                                    choose: 'B',
                                    score: 3,
                                    optionsName: 'B 态度挺好,就是偶尔没听过我的要求',
                                },{
                                    choose: 'C',
                                    score: 2,
                                    optionsName: 'C 态度强硬、不会听我们的合理要求',
                                },{
                                    choose: 'D',
                                    score: 0,
                                    optionsName: 'D 态度恶劣',
                                },
                            ]
                        }, {
                            type: 'checkbox',
                            topicName: '6, 您认为食堂所用大米、菜及肉类等原材料质量如何？', //题目
                            optionsScore: '', //得分
                            options:[
                                {
                                    choose: 'A',
                                    score: 5,
                                    optionsName: 'A 很好',
                                },{
                                    choose: 'B',
                                    score: 3,
                                    optionsName: 'B 较好',
                                },{
                                    choose: 'C',
                                    score: 2,
                                    optionsName: 'C 一般',
                                },{
                                    choose: 'D',
                                    score: 0,
                                    optionsName: 'D 较差',
                                }
                            ]
                        }, {
                            type: 'checkbox',
                            topicName: '7, 您认为食堂蔬菜等原材料新鲜程度如何？', //题目
                            optionsScore: '', //得分
                            options:[
                                {
                                    choose: 'A',
                                    score: 5,
                                    optionsName: 'A 很好',
                                },{
                                    choose: 'B',
                                    score: 3,
                                    optionsName: 'B 较好',
                                },{
                                    choose: 'C',
                                    score: 2,
                                    optionsName: 'C 一般',
                                },{
                                    choose: 'D',
                                    score: 0,
                                    optionsName: 'D 较差',
                                }
                            ]
                        }, {
                            type: 'checkbox',
                            topicName: '8, 你觉得员工餐厅每餐的汤类味道如何?', //题目
                            optionsScore: '', //得分
                            options:[
                                {
                                    choose: 'A',
                                    score: 5,
                                    optionsName: 'A 不错,很好喝',
                                },{
                                    choose: 'B',
                                    score: 3,
                                    optionsName: 'B 味道还行',
                                },{
                                    choose: 'C',
                                    score: 2,
                                    optionsName: 'C 不喜欢,因为不喜欢喝汤',
                                },{
                                    choose: 'D',
                                    score: 0,
                                    optionsName: 'D 非常难喝',
                                }
                            ]
                        }, {
                            type: 'checkbox',
                            topicName: '9, 您对食堂工作人员的卫生情况是否满意？？', //题目
                            optionsScore: '', //得分
                            options:[
                                {
                                    choose: 'A',
                                    score: 5,
                                    optionsName: 'A 很满意',
                                },{
                                    choose: 'B',
                                    score: 3,
                                    optionsName: 'B 比较满意',
                                },{
                                    choose: 'C',
                                    score: 2,
                                    optionsName: 'C 一般',
                                },{
                                    choose: 'D',
                                    score: 0,
                                    optionsName: 'D 不满意',
                                }
                            ]
                        }, {
                            type: 'checkbox',
                            topicName: '10, 食物中您发现异物的情况？', //题目
                            optionsScore: '', //得分
                            options:[
                                {
                                    choose: 'A',
                                    score: 5,
                                    optionsName: 'A 很干净卫生、没发现过',
                                },{
                                    choose: 'B',
                                    score: 3,
                                    optionsName: 'B 偶尔会有,不常见',
                                },{
                                    choose: 'C',
                                    score: 2,
                                    optionsName: 'C 发现过多次细小异物',
                                },{
                                    choose: 'D',
                                    score: 0,
                                    optionsName: 'D 经常发现',
                                }
                            ]
                        }, {
                            type: 'checkbox',
                            topicName: '11, 您认为食堂餐桌及时清理情况如何？', //题目
                            optionsScore: '', //得分
                            options:[
                                {
                                    choose: 'A',
                                    score: 5,
                                    optionsName: 'A 非常及时',
                                },{
                                    choose: 'B',
                                    score: 3,
                                    optionsName: 'B 较好',
                                },{
                                    choose: 'C',
                                    score: 2,
                                    optionsName: 'C 一般',
                                },{
                                    choose: 'D',
                                    score: 0,
                                    optionsName: 'D 较差',
                                }
                            ]
                        }, {
                            type: 'checkbox',
                            topicName: '12, 您对食堂管理信息公开透明度是否满意？', //题目
                            optionsScore: '', //得分
                            options:[
                                {
                                    choose: 'A',
                                    score: 5,
                                    optionsName: 'A 很满意',
                                },{
                                    choose: 'B',
                                    score: 3,
                                    optionsName: 'B 比较满意',
                                },{
                                    choose: 'C',
                                    score: 2,
                                    optionsName: 'C 一般',
                                },{
                                    choose: 'D',
                                    score: 0,
                                    optionsName: 'D 不满意',
                                }
                            ]
                        }, {
                            type: 'checkbox',
                            topicName: '13, 你觉得员工餐厅的就餐秩序如何？', //题目
                            optionsScore: '', //得分
                            options:[
                                {
                                    choose: 'A',
                                    score: 5,
                                    optionsName: 'A 井然有序,人人自觉排队',
                                },{
                                    choose: 'B',
                                    score: 3,
                                    optionsName: 'B 大部分人都排队,个别人插队',
                                },{
                                    choose: 'C',
                                    score: 2,
                                    optionsName: 'C 较多人不排队,造成后面长时间等待',
                                },{
                                    choose: 'D',
                                    score: 0,
                                    optionsName: 'D 完全没有秩序,一片混乱',
                                }
                            ]
                        }, {
                            type: 'checkbox',
                            topicName: '14, 您对目前食堂的满意度打几分？', //题目
                            optionsScore: '', //得分
                            options:[
                                {
                                    choose: 'A',
                                    score: 5,
                                    optionsName: 'A 100~90',
                                },{
                                    choose: 'B',
                                    score: 3,
                                    optionsName: 'B 90~85',
                                },{
                                    choose: 'C',
                                    score: 2,
                                    optionsName: 'C 85~70 ',
                                },{
                                    choose: 'D',
                                    score: 1,
                                    optionsName: 'D 70~60 ',
                                },{
                                    choose: 'E',
                                    score: 0,
                                    optionsName: 'E 60 以下',
                                }
                            ]
                        }, {
                            type: 'checkbox',
                            topicName: '15, 您希望食堂做出哪些方面的改进？', //题目
                            optionsScore: '', //得分
                            options:[
                                {
                                    choose: 'A',
                                    score: 0,
                                    optionsName: 'A 卫生',
                                },{
                                    choose: 'B',
                                    score: 0,
                                    optionsName: 'B 环境',
                                },{
                                    choose: 'C',
                                    score: 0,
                                    optionsName: 'C 菜品',
                                },{
                                    choose: 'D',
                                    score: 0,
                                    optionsName: 'D 服务',
                                },{
                                    choose: 'E',
                                    score: 0,
                                    optionsName: 'E 其他',
                                }
                            ]
                        },
                        {
                            type: 'textarea',
                            topicName: '16, 您对食堂有哪些期望、意见和建议？', //题目
                            optionsScore: '', //得分
                            options:[{
                                choose: 'A',
                                score: 0,
                                optionsName:''
                            }]
                        }
                    ]
                },
            }
        },
        methods:{
            /**
             *算总分
             **/
            handleClick(items, index, k){
                if(this.disabled){
                    return false
                }
                let score = 0;
                this.form.topics.map((i, n) => {
                    if(i.optionsScore!==0 && i.optionsScore && n !==14){
                        score += i.optionsScore
                    }
                    if(n==index){
                        i.optioo = items.choose
                    }
                })
                this.form.score = score;
            },
            /**
             * 验证
             **/
            handleValidate(){
                let status = true,n=0;
                // 验证
                for(let i=0; i<this.form.topics.length; i++ ){
                    //15、16题不计分，总分70分
                    //除了16题，所有题目必须填写
                    let type = typeof this.form.topics[i].optionsScore
                    if(i<14 && type!=='number' ){
                        status = false;
                        n =i;
                        break
                    }else if(i===14 && !this.form.topics[i].optionsScore){
                        status = false;
                        n =i;
                        break
                    }
                }
                if(!status){
                    this.$toast('请选择第'+(n+1)+'项！')
                    return false
                }
                Dialog.confirm({
                    message: '请确认是否要提交，提交后不可修改。',
                }).then(() => {
                    this.handleSubmit()
                })
            },
            /**
             * 提交
             **/
            handleSubmit(){
                this.loadingSub = true;
                application.addCanteenEvaluate(this.form).then(res=>{
                    if(res.code == 0){
                        this.loadingSub = false;
                        this.$router.push({
                            path: '/application/canteen/evaluate',
                        })
                    }
                }).catch(err=>{
                    this.loadingSub = false;
                });
            },
            /**
             * 获取评价
             **/
            handleDetail() {
                application.getCanteenEvaluate({id:this.listId}).then(res=> {
                    this.form =res.data;
                    // this.GetTotalScore()
                })
            }
        },
        mounted() {
            if(this.disabled){
                this.handleDetail()
            }
        }
    }
</script>

<style  lang="scss" scoped>
    .navbar{
        border-bottom: 1px solid #f5f5f5;
    }
    .view{
        background: #FFFFFF;
        height: calc(100vh + 1px);
        .content{
            padding-bottom: 5rem;
            .van-cell-group__title{
                color: #333333;
                /*background-color: #f5f5f5;*/
            }
        }
        .cellgroup.van-hairline--top-bottom::after{
            border:none
        }
        .van-checkbox-group>div{
            margin-bottom: 10px;
        }
        ::v-deep .van-checkbox{
            align-items: flex-start;
        }
        ::v-deep .van-checkbox__label{
            margin-top: -1px;
        }
        .formCtn{
            .van-field {
                padding: 0;
                &.van-cell--required::before {
                    z-index: 2;
                }
            }
            ::v-deep .van-field__value{
                background-color: #f2f2f2;
                border-radius: 4px;
                padding: 1rem 1rem 1rem 1.6rem;
            }
            ::v-deep .van-field--error .van-field__control, .van-field--error .van-field__control::placeholder{
                background-color: #FFF9E8;
            }
            ::v-deep .van-field--error .van-field__value{
                background-color: #FFF9E8;
            }
        }
        .btn{
            .van-button{
                padding: 0;
                margin: 0;
                border-radius: 99px;
            }

        }

    }
</style>